export default function Hero() {
  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Fashion%20editorial%20scene%20with%20clothing%20items%20hanging%20on%20minimal%20rack%20against%20warm%20greige%20studio%20backdrop%20soft%20diffused%20daylight%20from%20large%20window%20clean%20modern%20aesthetic%20sneakers%20hoodies%20bags%20and%20accessories%20artfully%20arranged%20below%20warm%20earthy%20neutral%20color%20palette&width=1800&height=1000&seq=hero-main-2701-x2&orientation=landscape"
        alt="Pandabuy Spreadsheet curated fashion finds collection"
        title="PandabuySpreadsheet Curated Fashion Finds 2026"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full max-w-[800px] mx-auto px-6 text-center">
        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.08] tracking-tight">
          Discover PandabuySpreadsheet
          <span className="block text-primary-300">Curated Fashion Finds 2026</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-white/80 max-w-[580px] mx-auto leading-relaxed">
          Access thousands of curated PandabuySpreadsheet lists for shoes, streetwear, tech, and luxury-inspired fashion — updated daily.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white/20 backdrop-blur-sm border border-white/30 text-white font-semibold text-base hover:bg-white/35 transition-all whitespace-nowrap cursor-pointer"
          >
            Pandabuy Sheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-line"></i>
          </a>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {[
            { icon: 'ri-refresh-line', text: 'Updated Daily Spreadsheets' },
            { icon: 'ri-check-double-line', text: '10,000+ Verified Listings' },
            { icon: 'ri-user-heart-line', text: 'Beginner-Friendly Guides' },
            { icon: 'ri-shield-check-line', text: 'No Signup Required' },
          ].map((item) => (
            <div key={item.text} className="flex flex-col items-center gap-2 text-white/90">
              <span className="w-10 h-10 flex items-center justify-center text-xl text-primary-300">
                <i className={item.icon}></i>
              </span>
              <span className="text-xs md:text-sm font-medium whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}